// AUTO-GENERATED. DO NOT EDIT.
// Source: scripts/i18n/generate_i18n_catalogs.mjs

export const platformAdminExecutionControlPlane = {
  controlPlaneFields: {
    activeWorkers: "稼働ワーカー",
    controlPlaneState: "制御面状態",
    criticalAlerts: "重大警告",
    warningAlerts: "警告件数",
    redis: "Redis スケジューリング",
    pendingOldest: "最古 pending",
    runningOldest: "最古 running",
    leaseRisk: "lease リスク",
    cancelRequested: "取消要求中",
    pendingWorkers: "配布ワーカー",
    retryWorkers: "再試行ワーカー",
    recoveryWorkers: "回復ワーカー",
    cleanupWorkers: "清理ワーカー",
    recentEventWindow: "統計ウィンドウ",
    recentClaimConflicted: "直近 claim 競合",
    recentRateLimited: "直近制限ブロック",
    recentCapabilityMismatched: "直近能力不一致",
    recentDispatchFailed: "直近配布失敗",
    capabilityBlockedActions: "能力不足アクション",
    workerPolicyCoverage: "worker ポリシー適用状況",
    workerPolicies: "worker ポリシー",
    remediation: "是正提案",
    actionBacklog: "アクション backlog",
  },
  remediationFields: {
    triggerShort: "トリガー {value}",
    capabilityShort: "能力 {value}",
  },
  remediationPriorities: {
    warning: "警告",
    critical: "重大",
  },
  remediationActions: {
    bring_up_stale_running_recovery_worker: "stale recovery worker を立ち上げる",
    bring_up_failed_cleanup_worker: "failed cleanup worker を立ち上げる",
    bring_up_auto_retry_worker: "auto retry worker を立ち上げる",
    bring_up_dispatch_worker: "dispatch worker を立ち上げる",
    add_capable_worker: "必要能力を持つ worker を追加する",
    increase_running_limit_or_scale_workers: "running 上限を上げるか worker を増やす",
    increase_pending_limit_or_reduce_submit_rate: "pending 上限を上げるか投入を抑える",
    investigate_dispatch_failures: "dispatch failure を調査する",
    drain_retryable_failed_backlog: "再試行可能失敗 backlog を解消する",
    reduce_claim_contention: "claim 競合を減らす",
    rebalance_capacity_or_submission_rate: "容量か投入レートを再調整する",
    align_worker_capabilities: "worker capability を揃える",
    drain_aged_backlog: "老化 backlog を解消する",
  },
  remediationReasons: {
    missing_worker_policy_coverage: "worker ポリシー適用が不足",
    missing_capable_worker: "必要能力を持つ worker が不足",
    running_limit_reached: "running 上限に到達",
    pending_limit_reached: "pending 上限に到達",
    recent_dispatch_failed: "直近で dispatch failure が発生",
    retry_pressure: "再試行圧力が蓄積",
    claim_conflicted: "claim 競合が発生",
    rate_limited: "レート制限に到達",
    capability_mismatched: "worker capability が不一致",
    queue_aging: "キュー老化",
  },
  workerPolicy: {
    covered: "適用済み {count}",
    missing: "不足 {count}",
    coverageSummary: "バックグラウンド処理能力カバレッジ：{covered} / {total}",
    noActiveWorkers: "利用可能な処理ノードなし",
    currentState: "現在の状態：{value}",
    impact: "影響：{value}",
    capabilityWithCount: "{label}（{count}）",
    capabilities: {
      pendingDispatch: "タスク配布",
      autoRetry: "自動再試行",
      staleRunningRecovery: "異常復旧",
      failedCleanup: "失敗インスタンス清理",
    },
    impacts: {
      pendingDispatch: "新規タスクが自動配布されません",
      autoRetry: "再試行可能タスクが自動再投入されません",
      staleRunningRecovery: "異常実行中タスクが自動復旧に入りません",
      failedCleanup: "失敗後のインスタンス清理が自動実行されません",
      unknown: "この処理能力は現在カバーされていません",
    },
  },
  actionBacklog: {
    currentState: "現在の状態：{value}",
    workerCoverage: "対応可能ノード：{count}",
    capacity: "実行中 {running}/{runningLimit} · 待機中 {pending}/{pendingLimit}",
    impacts: {
      capabilityBlocked: "このアクションを実行できるノードが不足しています",
      dispatchFailed: "このアクションで最近配布失敗が発生しており調査が必要です",
      retryPending: "このアクションには自動再試行待ちタスクがあります",
      queuePressure: "このアクションにはキュー圧力があります",
      normal: "現在は安定しています",
    },
  },
  alertStates: {
    normal: "正常",
    warning: "警告",
    critical: "重大",
  },
  backlogStates: {
    normal: "正常",
    warning: "警告",
    saturated: "逼迫",
  },
  backlogMetrics: {
    claimConflictedShort: "競合 {count}",
    rateLimitedShort: "制限 {count}",
    capabilityMismatchedShort: "能力 {count}",
    dispatchFailedShort: "配布失敗 {count}",
    retryableFailedShort: "再試行可能 {count}",
    autoRetryScheduledShort: "再試行待ち {count}",
    pendingAgeShort: "待機年齢 {count}s",
    runningAgeShort: "実行年齢 {count}s",
  },
} as const;
